import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import RenderFilterForm from "../../utils/filterForm";

class FilterForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    error: PropTypes.string
  };

  render() {
    return (
      <RenderFilterForm {...this.props} fields={[
        {'name': 'id', 'label': 'ID', 'placeholder': 'ID', 'type': 'number'},
        {'name': 'name', 'label': 'Name', 'placeholder': 'Name', 'type': 'text'},
      ]} />
    );
  }
}

export default reduxForm({
  form: 'filter_question_bank_category',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(FilterForm);
